<div id="cfc-egypt" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">

  <div class="cfc-banner">

    <div class="language_container">
      <div class="go_button default square sm" (click)="eventService.shareEvent()" style="margin-right:10px"><i
        class="icon-facebook"></i>Share
      </div>
      <div *ngIf="(langChosen=='ar')?true:false; else english">
        <button class="cfc-language-button" value="en" (click)="languageChange('en')">
          <p>English</p>
          <div class="flag en"></div>
        </button>
      </div>
      <ng-template #english>
        <button class="cfc-language-button" value="ar" (click)="languageChange('ar')">
          <p>العربية</p>
          <div class="flag ar"></div>
        </button>
      </ng-template>
    </div>
    <img src="assets/img/cfc/cfc-banner-fullwidth.jpg" class="img-responsive hidden-xs" alt="">

    <img src="assets/img/cfc/cfc-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md" alt="">


    <mat-tab-group class="cfc_tabs" (selectedIndexChange)="selectedIndexChange($event)"
                   [selectedIndex]="selectedIndex">

      <mat-tab label="tab1">
        <ng-template mat-tab-label>
          <i class="icon-doc-text-inv"></i>
          {{language?.Tournament_info}}
        </ng-template>

        <div class="container" style="background: #181637;">

          <div class="cfc-calendar">
            <i class="icon-calendar"></i>
            <h1>{{language?.Tournament_date}}</h1>
            <h1>{{language?.Tournament_time}}</h1>


          </div>
          <div class="cfc-rules">
            <img class="img-responsive hidden-xs hidden-sm" style="max-width:250px;"
                 src="assets/img/cfc/fortnite-character.jpg" alt="">
            <img class="img-responsive hidden-lg hidden-md" style="max-width:250px;"
                 src="assets/img/cfc/fortnite-character-sm.jpg" alt="">
            <div class="honor-rules" style="max-width: 600px;">
              <h1><i class="icon-doc-text-inv"></i>{{language?.Tournament_rules}}</h1>
              <pre>{{language?.Rules}}</pre>
            </div>
          </div>

          <div class="row" style="margin:10px 0 20px 0;">
            <div class="cfc-rules" style="justify-content: center; flex-flow:column; align-items: center;">
              <img src="assets/img/cfc/award.svg" style="min-width:250px; margin:0 auto;" alt=""
                   class="img-responsive">
              <h1 style="text-align: center; font-size:50px; text-transform: uppercase;">
                {{language?.Prizes}}</h1>

              <div class="prizes-container">
                <div class="prize_info">
                  <h1>{{language?.Grand_prizes}}</h1>
                </div>
                <!--<div class="prize_info">-->
                <!--<h1>#2 </h1>-->
                <!--<p>2nd Team wins 2 Playstation 4</p>-->
                <!--</div>-->
                <!--<div class="prize_info">-->
                <!--<h1>#3 </h1>-->
                <!--<p>3rd Team wins 2 Playstation 4</p>-->
                <!--</div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="character">

        </div>
      </mat-tab>

      <mat-tab label="tab2" id="test">
        <ng-template mat-tab-label>
          <i class="icon-knockout"></i>
          {{language?.Pointing_System}}
        </ng-template>

        <div class="cfc-rules">
          <div class="container">

            <div class="col-xs-12">

              <p class="rule_title"><i class="icon-ok"></i>{{language?.Pointing_Rules}}</p>

              <h1><i class="icon-knockout"></i>{{language?.Semi_final}}</h1>
              <p>{{language?.Semi_final_text}}</p>

              <h1><i class="icon-knockout"></i>{{language?.Final_Round}}</h1>
              <p>{{language?.Final_Round_text}}</p>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h1>Qualifications Round</h1>
                <pre>
                 <div class="pointing_table">
                   <ul>
                       <li style="border-radius: 10px 10px 0 0; justify-content: center">
                           <h1> kill = 50pt </h1>
                       </li>
                      <li class="title">
                       <p>{{language?.Rank}}</p>
                       <p>{{language?.Points}}</p>
                     </li>
                     <li>
                       <p>1</p>
                       <p>100 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>2</p>
                       <p>70 {{language?.Point}}</p>
                     </li>
                       <li>
                       <p>3-4</p>
                       <p>60 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>5-9</p>
                       <p>50 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>10-14</p>
                       <p>30 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>15-24</p>
                       <p>20 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>25</p>
                       <p>10 {{language?.Point}}</p>
                     </li>
                   </ul>
                 </div>
             </pre>

              </div>

              <div class="col-md-6">
                <h1> Finals Rounds</h1>
                <pre>
                 <div class="pointing_table">
                   <ul>
                       <li style="border-radius: 10px 10px 0 0; justify-content: center">
                           <h1> kill = 50pt </h1>
                       </li>
                      <li class="title">
                       <p>{{language?.Rank}}</p>
                       <p>{{language?.Points}}</p>
                     </li>
                     <li>
                       <p>1</p>
                       <p>110 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>2</p>
                       <p>80 {{language?.Point}}</p>
                     </li>
                       <li>
                       <p>3</p>
                       <p>70 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>4</p>
                       <p>60 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>5</p>
                       <p>50 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>6</p>
                       <p>30 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>7</p>
                       <p>30 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>8</p>
                       <p>20 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>9</p>
                       <p>20 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>10</p>
                       <p>20 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>11</p>
                       <p>10 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>12</p>
                       <p>10 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>13</p>
                       <p>10 {{language?.Point}}</p>
                     </li>
                   </ul>
                 </div>
             </pre>

              </div>
            </div>

          </div>
        </div>

      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="icon-knockout"></i>
          {{language?.Bracket}}
        </ng-template>

        <div class="container">
          <div class="spacer md"></div>
          <mat-tab-group class="cfc_tabs">
            <mat-tab *ngFor="let day of eventService?.cfcLeaderBoard;let board_index=index">
              <ng-template mat-tab-label>
                <!--<i class="icon-knockout"></i>-->
                {{getDayName(board_index+1)}}
              </ng-template>
              <!--<div class="spacer sm"></div>-->
              <div class="cfc-day-info" *ngIf="day?.length>0">
                <h1><i class="icon-calendar"></i>{{eventService.cfcLeaderBoardStats[board_index]?.date}}
                </h1>
                <!--<p><i class="icon-users"></i> {{eventService.cfcLeaderBoardStats[board_index]?.total_participants}}-->
                <!--</p>-->
              </div>
              <!--<div class="spacer md"></div>-->
              <div class="pointing_table" *ngIf="day?.length>0; else noLeaderBoard">
                <ul>
                  <li class="title">
                    <p class="rank">{{language?.Rank}}</p>
                    <p class="team">{{language?.Team}}</p>
                    <p>DMG Rate</p>
                    <p>{{language?.Points}}</p>
                  </li>
                  <div style="border-bottom: #794b8a 1px dashed" class="flex_block column winner"
                       *ngFor="let board of day|participantSort:'fortnite':false; let rank=index">
                    <li>
                      <p class="rank">{{rank+1}}</p>
                      <p class="team"> {{board.participant_name}}</p>
                      <p>
                        {{getDamageRate(board.damage_rate)?getDamageRate(board.damage_rate):0}}</p>
                      <p> {{board.score?board.score:0}}</p>
                    </li>
                    <li class="members" *ngIf="board.members.data?.length != 0">
                      <i class="icon-users"></i>
                      <div *ngFor="let member of board.members.data">
                        <p>{{member.username}}</p>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
              <ng-template #noLeaderBoard>
                <div class="big_block points cfc">
                  <div class="content text-center">
                    <p>No bracket yet.</p>
                  </div>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-tab>
    </mat-tab-group>

  </div>


</div>

<!--footer-->
<div class="cfc_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/logo-gray.svg" alt=""></a>

  <p>This tournament is organized by <a href="http://gbarena.com/arena/kom" target="_blank">KOM</a><br> hosted
    and powered by
    <a href="https://gbarena.com" target="_blank">GBarena</a>.
  </p>

</div>
